
import React from 'react';
import { IconProps } from '../../types/types';

const SelectIcon: React.FC<IconProps> = ({ size = '18', color = '#1E1E1E' }) => (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.00065 14.6693H10.0006C13.334 14.6693 14.6673 13.3359 14.6673 10.0026V6.0026C14.6673 2.66927 13.334 1.33594 10.0006 1.33594H6.00065C2.66732 1.33594 1.33398 2.66927 1.33398 6.0026V10.0026C1.33398 13.3359 2.66732 14.6693 6.00065 14.6693Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.00098 16.6676H12.001C14.6261 16.6676 16.6676 14.0625 16.6676 12.001V5.00098" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>


);

export default SelectIcon;